
interface HowItWorksSectionProps {
  visible: boolean;
}

const HowItWorksSection = ({ visible }: HowItWorksSectionProps) => {
  const steps = [
    "Answer a series of scientifically designed questions based on John L. Holland's RIASEC model.",
    "Our system analyzes your responses to identify your dominant personality types (Realistic, Investigative, Artistic, Social, Enterprising, Conventional).",
    "Receive a personalized career report matching your Holland Code to ideal career paths, education options, and skills to develop.",
    "Gold Package: Get a one-on-one session with a career expert to discuss your Holland Code results in detail."
  ];

  return (
    <section className={`py-20 px-4 sm:px-6 md:px-8 bg-gray-50 transition-all duration-700 ease-in-out delay-400 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-blue mb-12">
          How Our Career Assessment Works?
        </h2>
        <div className="space-y-6">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="flex items-start p-6 bg-white rounded-xl shadow-soft transition-all duration-300 hover:shadow-elevated"
              style={{ transitionDelay: `${index * 100 + 400}ms` }}
            >
              <div className="flex-shrink-0 mr-4">
                <span className="flex items-center justify-center h-10 w-10 rounded-full bg-brand-blue text-white font-medium">
                  {index + 1}
                </span>
              </div>
              <p className="text-lg text-gray-700">{step}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
